import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=6d20d152&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=6d20d152&prod&scoped=true&lang=css"
import style1 from "./SearchHistory.vue?vue&type=style&index=1&id=6d20d152&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20d152",
  null
  
)

export default component.exports